var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Axios from "axios";
import messageTypeDecorator from "../reflect/messageTypeDecorator";
var MessageService = (function () {
    function MessageService() {
    }
    MessageService.prototype.getMessage = function (params) {
        return Axios.get("supplierclientapi/notice/list", { params: params });
    };
    MessageService.prototype.changeStatus = function (params) {
        return Axios.post("supplierclientapi/notice/update", params);
    };
    MessageService.prototype.getNoticeCheck = function (params) {
        return Axios.get("/supplierclientapi/notice/check", { params: params });
    };
    MessageService.createInstance = function () {
        MessageService.getInstance();
    };
    MessageService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    __decorate([
        messageTypeDecorator
    ], MessageService.prototype, "getMessage", null);
    return MessageService;
}());
export default MessageService;
